var _this = this;

/**
 * Fonction ici pour utiliser process.env.SITE pour mettre des spécifités.
 */
module.exports.getBordureMin = function () {
  return 2;
};
/**
 * Catégories pour lesquelles on ne propose pas de passe partout
 * Il s'agit des catégories en BDD, non pas de celles spécifiques à certains sites (ex esm)
 */


module.exports.categsNoPasse = [19, 10, 18, 3, 13, 21, 16, 17];
/**
 * Liste des types de tirages disponibles
 */

module.exports.tirages = [{
  title: "Papier qualité professionnelle 260g",
  value: "tirage"
}, {
  title: "Papier qualité haut de gamme BARYTA 310g",
  value: "tirage_haut_de_gamme"
}, {
  title: "Sublimation sur Chromaluxe",
  value: "tirage_sublimation"
}];
/**
 *
 * @param {object} baguetteExt produit correpondant à pageProduit.produit
 * @param {object} pageProduit en provenance de redux ou sauvegarde panier
 * @param {array} pa liste des produits annexes
 * @param {object} photosR en provenance de redux ou sauvegarde panier
 */

module.exports.getOptions = function (product, pageProduit, photosR) {
  var debug_ = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  //console.log(process.env.SITE);
  var debug = debug_ && process.env.NODE_ENV !== "production";

  var _require = require("@bko/profcadresprix"),
      getSizeInfos = _require.getSizeInfos;

  var _getSizeInfos = getSizeInfos(pageProduit, product, pageProduit.doublo),
      largeurIntra = _getSizeInfos.largeurIntra,
      hauteurIntra = _getSizeInfos.hauteurIntra,
      perimetreIntra = _getSizeInfos.perimetreIntra;

  var conditions = {};
  conditions.doublo = pageProduit.dimensionsValid && !pageProduit.dimensionsDefault && product.doublo_dispos.length >= 1;
  conditions.isorel = (conditions.doublo && pageProduit.doublo !== null || !conditions.doublo) && pageProduit.service === "coupe_assemble_option" && pageProduit.dimensionsValid && ![475, 540].includes(product.fa_id) && photosR.tirage === null && product.cat_id !== 10 && product.cat_id !== 18 && !pageProduit.dimensionsDefault;
  conditions.passePartout = (conditions.isorel && pageProduit.isorel || !conditions.isorel) && (conditions.doublo && pageProduit.doublo !== null || !conditions.doublo) && pageProduit.service === "coupe_assemble_option" && !pageProduit.dimensionsDefault && pageProduit.dimensionsValid && !_this.categsNoPasse.includes(product.cat_id) && pageProduit.isorel !== null && ![475, 540].includes(product.fa_id) && largeurIntra + (["aucun", null].includes(pageProduit.pp.type) ? _this.getBordureMin() * 2 : 0) <= product.ba_maxi && hauteurIntra + (["aucun", null].includes(pageProduit.pp.type) ? _this.getBordureMin() * 2 : 0) <= product.ba_maxi;
  conditions.service = (conditions.doublo && pageProduit.doublo !== null || !conditions.doublo) && pageProduit.dimensionsValid && !pageProduit.dimensionsDefault;
  conditions.cartonBarriere = (conditions.passePartout && (!pageProduit.pp.default || pageProduit.pp.type === "aucun") || !conditions.passePartout) && (conditions.doublo && pageProduit.doublo !== null || !conditions.doublo) && pageProduit.service === "coupe_assemble_option" && pageProduit.dimensionsValid && !pageProduit.dimensionsDefault && ![475, 540].includes(product.fa_id) && pageProduit.isorel === true && photosR.tirage !== "tirage_sublimation" && product.cat_id !== 3 && product.cat_id !== 10 && product.cat_id !== 18;
  conditions.rehausse = (conditions.cartonBarriere && pageProduit.cartonBarriere !== null || !conditions.cartonBarriere) && (conditions.passePartout && (!pageProduit.pp.default || pageProduit.pp.type === "aucun") || !conditions.passePartout) && !pageProduit.dimensionsDefault && pageProduit.dimensionsValid && Object.keys(photosR.photos).length === 0 && product.cat_id == 1 && product.fa_id !== 459 && pageProduit.isorel;
  conditions.protection = (conditions.cartonBarriere && pageProduit.cartonBarriere !== null || !conditions.cartonBarriere) && (conditions.rehausse && pageProduit.rehausse !== null && (pageProduit.rehausse === "none" || pageProduit.rehausseColor !== null) || !conditions.rehausse) && (conditions.passePartout && (!pageProduit.pp.default || pageProduit.pp.type === "aucun") || !conditions.passePartout) && ((conditions.isorel || photosR.tirage !== null) && pageProduit.isorel || product.cat_id === 16) && pageProduit.service === "coupe_assemble_option" && pageProduit.dimensionsValid && !pageProduit.dimensionsDefault && product.cat_id !== 3 && product.cat_id !== 10 && product.cat_id !== 18 && (pageProduit.doublo === null || pageProduit.doublo !== null && pageProduit.doublo.cat_id !== 10) && // Pas de doublo chassis peinture
  ![540].includes(product.fa_id) && // 540 : Astral, 475 : Entre deux verres
  photosR.tirage !== "tirage_sublimation";
  conditions.kitMontage = pageProduit.dimensionsValid && !pageProduit.dimensionsDefault && pageProduit.service === "precoupe" && product.cat_id !== 6; // aluminium

  conditions.ajouterPanier = pageProduit.dimensionsValid && !pageProduit.dimensionsDefault && (conditions.passePartout && (!pageProduit.pp.default || pageProduit.pp.type === "aucun") || !conditions.passePartout) && (conditions.protection && pageProduit.protection !== null || !conditions.protection) && (conditions.cartonBarriere && pageProduit.cartonBarriere !== null || !conditions.cartonBarriere) && (conditions.rehausse && pageProduit.rehausse !== null && (pageProduit.rehausse === "none" || pageProduit.rehausseColor !== null) || !conditions.rehausse) && (conditions.kitMontage && pageProduit.kitMontage !== null || !conditions.kitMontage) && (conditions.isorel && pageProduit.isorel !== null || !conditions.isorel) && (conditions.doublo && pageProduit.doublo !== null || !conditions.doublo) && (pageProduit.service !== null || photosR.tirage === "tirage_sublimation") && (hauteurIntra >= product.ba_mini || conditions.passePartout) && (largeurIntra >= product.ba_mini || conditions.passePartout) && hauteurIntra <= product.ba_maxi && largeurIntra <= product.ba_maxi && (perimetreIntra <= product.ba_perimetre_maxi || pageProduit.service === "precoupe" && perimetreIntra <= 600);
  conditions.resetButton = !pageProduit.dimensionsDefault && Object.keys(photosR.photos).length === 0;
  return conditions;
};

module.exports.getEtape = function (product, pageProduit, photosR) {
  var debug_ = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var order = ["dimensions", "doublo", "isorel", "kitMontage", "passePartout", "cartonBarriere", "rehausse", "protection", "ajouterPanier"];

  var conditions = _this.getOptions(product, pageProduit, photosR, debug_);

  var curStep = "dimensions";
  order.forEach(function (step) {
    if (conditions[step]) curStep = step;
  });
  return curStep;
};
/**
 * Retourne la liste des services disponibles
 * @param {*} product
 * @param {*} pageProduit
 * @param {*} photosR
 */


module.exports.getServices = function () {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var pageProduit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var photosR = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var _require2 = require("@bko/profcadresprix"),
      getSizeInfos = _require2.getSizeInfos;

  var services = {
    coupe_assemble_option: {
      iconProps: {},
      title: "Coup\xE9\xA0assembl\xE9"
    },
    precoupe: {
      iconProps: {
        precoupe: true
      },
      title: "Précoupé"
    }
  };

  if (product === null && pageProduit === null && photosR === null) {
    return services;
  }

  if (product.doublo_dispos.length >= 1 || [18, 16].includes(product.cat_id) || // Caisse amérique peinture / entre deux verres
  Object.keys(photosR.photos).length >= 1 || product.fa_libelle === "ALU 010" || product.fa_libelle === "ALU 01" || [(492, 493, 475, 540)].includes(product.fa_id) || ![null, "aucun"].includes(pageProduit.pp.type)) delete services.precoupe;

  var _getSizeInfos2 = getSizeInfos(pageProduit, product, pageProduit.doublo),
      perimetreIntra = _getSizeInfos2.perimetreIntra;

  if (perimetreIntra > product.ba_perimetre_maxi && perimetreIntra <= 600) delete services.coupe_assemble_option;
  return services;
};
/**
 * Retourne la liste des protections disponibles
 * @param {*} product
 * @param {*} pageProduit
 * @param {*} photos
 */


module.exports.getProtection = function () {
  var _pageProduit$pp, _pageProduit$pp2, _pageProduit$pp2$pp, _pageProduit$pp3, _pageProduit$pp3$pp, _pageProduit$pp4, _pageProduit$pp4$pp;

  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var pageProduit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var photos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var _require3 = require("@bko/profcadresprix"),
      getSizeInfos = _require3.getSizeInfos;

  var protections = {
    aucune: {
      title: "Aucune",
      order: 0
    },
    plexi_normal: {
      title: "Plexi normal traité anti-UV",
      order: 1
    },
    verre_normal: {
      title: "Verre normal",
      order: 3
    },
    verre_invisible: {
      title: "Verre qualité musée",
      order: 5
    },
    verre_anti_reflet: {
      title: "Verre anti-reflet",
      order: 4
    },
    plexi_anti_reflet: {
      title: "Plexi anti-reflet traité anti-UV",
      order: 2
    },
    double_verre_normal: {
      title: "Double verre normal",
      order: 2
    },
    double_verre_invisible: {
      title: "Double verre qualité musée",
      order: 2
    }
  };

  if (product === null && pageProduit === null && photos === null) {
    return protections;
  }

  var _getSizeInfos3 = getSizeInfos(pageProduit, product),
      fullPerimetre = _getSizeInfos3.fullPerimetre;

  if (fullPerimetre > 299) {
    delete protections.verre_anti_reflet;
    delete protections.verre_invisible;
    delete protections.verre_normal;
  }

  if ((pageProduit === null || pageProduit === void 0 ? void 0 : (_pageProduit$pp = pageProduit.pp) === null || _pageProduit$pp === void 0 ? void 0 : _pageProduit$pp.pp) !== null && ([18, 22].includes(pageProduit === null || pageProduit === void 0 ? void 0 : (_pageProduit$pp2 = pageProduit.pp) === null || _pageProduit$pp2 === void 0 ? void 0 : (_pageProduit$pp2$pp = _pageProduit$pp2.pp) === null || _pageProduit$pp2$pp === void 0 ? void 0 : _pageProduit$pp2$pp.pat_id) || pageProduit !== null && pageProduit !== void 0 && (_pageProduit$pp3 = pageProduit.pp) !== null && _pageProduit$pp3 !== void 0 && (_pageProduit$pp3$pp = _pageProduit$pp3.pp) !== null && _pageProduit$pp3$pp !== void 0 && _pageProduit$pp3$pp.pa_reference && pageProduit !== null && pageProduit !== void 0 && (_pageProduit$pp4 = pageProduit.pp) !== null && _pageProduit$pp4 !== void 0 && (_pageProduit$pp4$pp = _pageProduit$pp4.pp) !== null && _pageProduit$pp4$pp !== void 0 && _pageProduit$pp4$pp.pa_reference.includes("+")) || product.cat_id === 1 && pageProduit.rehausse !== null && pageProduit.rehausse !== "none" || product.fa_id === 459) {
    delete protections.verre_anti_reflet;
    delete protections.plexi_anti_reflet;
  }

  if (product.cat_id === 16) {
    delete protections.plexi_normal;
    delete protections.plexi_anti_reflet;
    delete protections.verre_anti_reflet;
    delete protections.verre_normal;
    delete protections.plexi_normal;
    delete protections.verre_invisible;
  } else {
    delete protections.double_verre_invisible;
    delete protections.double_verre_normal;
  }

  if (product.fa_id === 475) {
    delete protections.aucune;
    delete protections.plexi_normal;
    return protections;
  } else {
    if (Object.keys(photos.photos).length >= 1 || typeof pageProduit.standard !== "undefined" && pageProduit.standard) delete protections.aucune;
    return protections;
  }
};